import { useEffect, useState } from 'react';

interface UseDetectKeyboardOpen {
  minKeyboardHeight?: number;
  defaultValue?: boolean;
}

/**
 * Hook which observes soft keyboard open. Return boolean
 * you can set default value and minKeyboardHeight
 */
export const useDetectKeyboardOpen = (
  options?: UseDetectKeyboardOpen,
): { isKeyboardOpen: boolean; viewPortHeight: number } => {
  const { minKeyboardHeight = 300, defaultValue = false } = options || {};
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultValue);
  const [viewPortHeight, setViewPortHeight] = useState(
    window?.visualViewport?.height || 0,
  );

  useEffect(() => {
    const listener = () => {
      const visualViewportHeight = window?.visualViewport?.height || 0;
      const windowScreenHeight = window?.screen?.height || 0;
      const isOpenNow =
        windowScreenHeight - minKeyboardHeight > visualViewportHeight;

      if (isKeyboardOpen !== isOpenNow) {
        setIsKeyboardOpen(isOpenNow);
        setViewPortHeight(visualViewportHeight);
      }
    };

    if (typeof visualViewport !== 'undefined') {
      window?.visualViewport?.addEventListener('resize', listener);
    }

    return () => {
      if (typeof visualViewport !== 'undefined') {
        window?.visualViewport?.removeEventListener('resize', listener);
      }
    };
  }, [isKeyboardOpen, minKeyboardHeight]);

  return { isKeyboardOpen, viewPortHeight };
};
